import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileFeatureStore } from '@lib/store';
import { cn } from '@shared/utils';
import { UserType } from '@shared/api';
import { Icon, Text } from '@shared/widgets';
import AccountIcon from '@assets/icons/account.svg';
import CardIcon from '@assets/icons/card.svg';

interface ShortInfoProps {
  type: UserType;
  locked: boolean;
  cards: number;
  accounts: number;
}

export const ShortInfo = (props: ShortInfoProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const { t } = useTranslation('userManagement');

  if (props.type === UserType.Admin || !profileFeatureStore.data?.userManagement.managerAccountsOrCardsPermissions) return null;
  return (
    <div className={cn(props.locked && 'pointer-events-none select-none opacity-50')}>
      <div className='border-t border-t-gray-black px-6 pb-6 pt-8'>
        <div className='-mx-2 flex'>
          {props.type === UserType.Manager && (
            <div className='flex items-center px-2'>
              <div className='mr-3 flex h-8 w-8 flex-none items-center justify-center bg-ice dark:bg-eerie-black'>
                <Icon icon={<AccountIcon />} color='secondary-inverse' />
              </div>
              <Text>{t('user.info.userType.manager', { count: props.accounts })}</Text>
            </div>
          )}
          {props.type === UserType.User && (
            <div className='flex items-center px-2'>
              <div className='mr-3 flex h-8 w-8 flex-none items-center justify-center bg-ice dark:bg-eerie-black'>
                <Icon icon={<CardIcon />} color='secondary-inverse' />
              </div>
              <Text>{t('user.info.userType.user', { count: props.cards })}</Text>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
